import { render, staticRenderFns } from "./RVBGridImprovementCount.vue?vue&type=template&id=477f1252"
import script from "./RVBGridImprovementCount.vue?vue&type=script&lang=js"
export * from "./RVBGridImprovementCount.vue?vue&type=script&lang=js"
import style0 from "./RVBGridImprovementCount.vue?vue&type=style&index=0&id=477f1252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports